module.exports = __webpack_public_path__ + "static/img/wdl.14dd0b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wdl.png
// module id = 29T/
// module chunks = 1